export default {


   badge: "Frequently Asked Questions",
    title: "How Can We Help You?",
    subtitle: "Here you'll find answers to some of the most common questions.",
    items: [
      {
        question: "How do I register on the website?",
        answer: "To register, simply click the 'Sign Up' button at the top of the page and fill out the registration form with your accurate information. Your account will be activated after email verification.",
      },
      {
        question: "How do I make a purchase?",
        answer: "Select the product you want and add it to your cart. Then, go to the cart page and complete your purchase by clicking the 'Checkout' button and following the steps. An instructional video is available <a href='#'>here</a> for more guidance.",
      },
      {
        question: "How can I download audio files (voice notes)?",
        answer: "After purchasing a course or product, the download links for audio files will be available in your 'My Account' page under 'Purchased Products'. Clicking the download button will save the respective file.",
      },
      {
        question: "Can I edit my account information?",
        answer: "Yes, after logging into your account, you can navigate to the 'My Profile' section to edit your information, including your name, email, and password.",
      },
      {
        question: "How do I contact support?",
        answer: "To contact support, you can use the 'Contact Us' page or email us at support@zabankid.com. Our support hours are also listed on the contact page.",
      },
    ],


};
